import { atom } from "jotai";

export const isBackFromCheckoutAtom = atom(false);
